import axios from "axios";

export default function getCompanyDropdown() {
  return new Promise((resolve, reject) => axios
    .get(`/account/system-admin/api/v1/company-dropdown`)
    .then((response) => resolve(response.data))
    .catch((error) => reject(error.message))
  );
}
